import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmostraService } from 'src/app/services/amostra.service';

@Component({
  selector: 'app-imprimir-programa-trabalho',
  templateUrl: './imprimir-programa-trabalho.component.html',
  styleUrls: ['./imprimir-programa-trabalho.component.scss']
})
export class ImprimirProgramaTrabalhoComponent implements OnInit {

  model: any;
  id: number = 0;
  idAmostra: any
  indice: any;
  nomeAmostra: any
  Ug: any

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private amostraService: AmostraService) {
    const id = this.route.snapshot.paramMap.get("id");
    const path = this.route.snapshot.url.pop()?.toString();
    if (id) {
      this.id = parseInt(id, 10);
    }
    const navigation = this.router.getCurrentNavigation();
    this.idAmostra = navigation?.extras?.state?.['idAmostra'];
    this.indice = navigation?.extras?.state?.['indice'];
    this.getAmostra('planejamento')
  }

  ngOnInit(): void {
    // this.getAmostra('planejamento')
  }

  getAmostra(tipoAmostra: any) {
    this.amostraService
      .obterAmostra(this.id, tipoAmostra)
      .then((res) => {
        const baseData = res.dados.filter(amostra => this.idAmostra.includes(amostra.id))
        this.nomeAmostra = baseData[0].nome
        this.Ug = `${baseData[0].amostraUnidadeGestoras[0]?.unidadeGestora.nome}-${baseData[0].amostraUnidadeGestoras[0]?.unidadeGestora.sigla}`;
        this.model = this.extrairProcedimentosEcriterios(baseData)
      })
      .catch((err) => {
      })
  }


  extrairTextoLimpo(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent?.trim() ?? '';
  }

  extrairProcedimentosEcriterios(dados: any[]): { codigo: string; procedimento: string; criterioAplicavel: string, ordem: any }[] {
    const resultado: { codigo: string; procedimento: string; criterioAplicavel: string, ordem: any }[] = [];
    let contador = 1;

    // Percorre todas as amostras
    for (const amostra of dados) {
      const questoes = amostra.planejamentoAmostraMatrizQuestoes || [];

      for (const questaoItem of questoes) {
        const questao = questaoItem.questaoPlanejamento;

        resultado.push({
          codigo: `Q.${questao.ordem.toString().padStart(2, '0')}`,
          procedimento: this.extrairTextoLimpo(questao.nome),
          criterioAplicavel: this.extrairTextoLimpo(questao.legislacaoAplicavelCriterio),
          ordem: questao.ordem
        });

        contador++;
      }
    }

    resultado.sort((a, b) => a.ordem - b.ordem);

    const vistos = new Set<string>();
    const unicos: typeof resultado = [];
    for (const item of resultado) {
      const key = `${item.ordem}§${item.procedimento}§${item.criterioAplicavel}`; 
      if (!vistos.has(key)) {
        vistos.add(key);
        unicos.push(item);
      }
    }

    return unicos;
  }

  cancelar() {
    this.router.navigate([`planejamento/${this.id}/planejar`], { state: { aba: 10 } })
  }

  filtrarAmostrasPorIds(amostras: any[], ids: any[]): any[] {
    return amostras.filter(amostra => ids.includes(amostra.id));
  }

}
